import { Play } from "./styles";
import { useTheme } from "styled-components";
import Icon from "../../../Icon";
import PlayEmptyIcon from "../../../../assets/icons/icon-cool/outline/Player/Play.svg";
import PlayFilledIcon from "../../../../assets/icons/icon-cool/filled/Player/Play.svg";

interface ComponentProps {
  active?: boolean
}

const Component = ({ active }: ComponentProps) => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };
  return (
    <Play>
      <Icon
        icon={active ? PlayFilledIcon : PlayEmptyIcon}
        size="16px"
        color={theme.colors.Primary}
      />
    </Play>
  );
};

export default Component;
